import { useMerchant, useWorkspaceId } from "@/providers/MerchantProvider";

// The merchant-scoped URL prefix — "/merchant/<id>", or "/workspace/<id>/merchant/<id>" when
// the current page is nested under a workspace, since the same destination needs to work
// whether reached standalone or from a workspace. Build a full destination by concatenating
// the desired path, e.g. `<Link to={scopedUrl + "/configure-safety"}>`. TanStack Router
// resolves an already-interpolated path string like this at face value, so no `params` object
// is needed even for routes with their own dynamic segments — just concatenate the real value.
export const useScopedUrl = () => {
  const merchantId = useMerchant();
  const workspaceId = useWorkspaceId();

  return workspaceId ? `/workspace/${workspaceId}/merchant/${merchantId}` : `/merchant/${merchantId}`;
};
